import type {
  NearbyBillboardsResponse,
  NearestBillboard,
} from '@/features/billboards/api/billboardApi';

export const NEARBY_RADIUS_OPTIONS = [1, 2, 3, 5, 10, 15, 20, 25, 30, 40, 50] as const;

export const NEARBY_DEFAULT_RADIUS: (typeof NEARBY_RADIUS_OPTIONS)[number] = 5;

export const NEARBY_DEFAULT_CENTER = { lat: 28.7041, lng: 77.1025 };

export function extractNearbyBillboards(
  response?: NearbyBillboardsResponse,
  city?: string,
): NearestBillboard[] {
  if (!response) return [];

  const rawList = (() => {
    const { data } = response;
    if (Array.isArray(data)) return data;
    if (Array.isArray(data?.billboards)) return data.billboards;
    if (Array.isArray(response.billboards)) return response.billboards;
    return [];
  })();

  const seen = new Set<string>();
  const normalizedCity = city?.trim().toLowerCase();

  return rawList.filter((item) => {
    const id = item._id || item.id;
    if (id) {
      if (seen.has(id)) return false;
      seen.add(id);
    }

    if (normalizedCity) {
      const itemCity = (item.address?.city || item.city || '')
        .trim()
        .toLowerCase();
      if (
        itemCity &&
        itemCity !== normalizedCity &&
        !itemCity.includes(normalizedCity) &&
        !normalizedCity.includes(itemCity)
      ) {
        return false;
      }
    }

    return true;
  });
}
